import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const ErrorCircleIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Error</title>
    <path d="M24,4A20,20,0,1,0,44,24,20,20,0,0,0,24,4Zm0,36A16,16,0,1,1,40,24,16,16,0,0,1,24,40Z" />
    <polygon points="29.66 14.1 24 19.76 18.34 14.1 14.1 18.34 19.76 24 14.1 29.66 18.34 33.9 24 28.24 29.66 33.9 33.9 29.66 28.24 24 33.9 18.34 29.66 14.1" />
  </IconBase>
);
